import {Component, Input} from '@angular/core';
import {CustomFormControl} from '../custom-form-control';

@Component({
    selector: 'app-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.less'],
})
export class TextareaComponent extends CustomFormControl {
    @Input() placeholder = '';
    @Input() size: 'large' | 'small' | 'default' = 'default';
    @Input() rows = 4;
    @Input() maxlength: number;
    @Input() textOnDisabled = false;
}
